import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { Subscription } from 'rxjs';
import { environment } from '../environments/environment';
import { patchTrimbleSerialPkce } from '../services/auth/trimble-serial-pkce';
import { ScitBffSessionKeepAliveService } from '../services/viewer/scit-bff-session-keep-alive.service';

export class AuthenticationConfigBuilder {
  static authConfig: AuthConfig = {};
  static oauthSubscription?: Subscription;
  static isInitializing = true;

  static buildConfig(config: any) {
    this.authConfig = {
      issuer: config.issuer,
      loginUrl: config.loginUrl,
      tokenEndpoint: config.tokenEndpoint,
      logoutUrl: config.logoutUrl,
      clientId: config.clientId,
      scope: config.scope,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      showDebugInformation: !environment.production,
      responseType: 'code',
      requireHttps: true,
      requestAccessToken: true
    };
  }
}

/** Establishes the viewer BFF session cookie on the BFF host (e.g. localhost:5002). */
function ensureBffViewerSession(keepAliveService: ScitBffSessionKeepAliveService): void {
  if (!environment.mayaViewer?.enabled) {
    return;
  }
  keepAliveService.start();
}

function isBffSessionOAuthEvent(eventType: string): boolean {
  return eventType === 'token_received' || eventType === 'token_refreshed';
}

function isBffSessionEndOAuthEvent(eventType: string): boolean {
  return eventType === 'session_terminated' || eventType === 'logout';
}

export function authInit(
  oauthService: OAuthService,
  keepAliveService: ScitBffSessionKeepAliveService
): () => Promise<void> {
  return async () => {
    if (!environment.mock) {
      AuthenticationConfigBuilder.buildConfig(environment.authConfig);
      oauthService.configure(AuthenticationConfigBuilder.authConfig);
      patchTrimbleSerialPkce(oauthService);
      oauthService.setStorage(sessionStorage);
      oauthService.setupAutomaticSilentRefresh();

      if (AuthenticationConfigBuilder.oauthSubscription) {
        AuthenticationConfigBuilder.oauthSubscription.unsubscribe();
      }

      AuthenticationConfigBuilder.oauthSubscription = oauthService.events.subscribe((event) => {
        if (isBffSessionOAuthEvent(event.type)) {
          ensureBffViewerSession(keepAliveService);
        }
        if (isBffSessionEndOAuthEvent(event.type)) {
          keepAliveService.stop();
        }
      });

      const loggedIn = await oauthService.loadDiscoveryDocumentAndTryLogin();

      if (loggedIn) {
        ensureBffViewerSession(keepAliveService);
      }
    }
  };
}
